import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ account, calendar, nextCalendar }) =>
    present(
      repository
        .editPersonalWeeklyCalendar(account.resource, calendar, nextCalendar)
        .then(() => ({
          account,
          calendar,
          nextCalendar,
        }))
        .catch(() =>
          Promise.reject({
            account,
            calendar,
            nextCalendar,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
